exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".Post__post___1olw8 {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + " 0 0;\n}\n\n.Post__leadImage___SsiLe {\n    width: 100%;\n\theight: 100%;\n\tmin-height: 20rem;\n    background-color: #ffffff;\n}\n\n.Post__statsContainer___1IaRz {\n    display: flex;\n\tjustify-content: space-evenly;\n}\n\n.Post__buttonContainer___WsAj7 {\n    flex: 1;\n}\n\n.Post__itemRoot___2D9j9 {\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + "",
	"mainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "",
	"primaryColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["primaryColour"] + "",
	"post": "Post__post___1olw8",
	"leadImage": "Post__leadImage___SsiLe",
	"statsContainer": "Post__statsContainer___1IaRz",
	"buttonContainer": "Post__buttonContainer___WsAj7",
	"itemRoot": "Post__itemRoot___2D9j9"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/Post.icss
// module id = 1505
// module chunks = 0